import { render, staticRenderFns } from "./PointDetailsDialog.vue?vue&type=template&id=3f0268ea&scoped=true"
import script from "./PointDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PointDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./PointDetailsDialog.vue?vue&type=style&index=0&id=3f0268ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0268ea",
  null
  
)

export default component.exports